import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group col-sm-12" }
const _hoisted_6 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "badge bg-danger rounded-pill ms-2"
}
const _hoisted_9 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WithdrawalRequests = _resolveComponent("WithdrawalRequests")!
  const _component_Deposits = _resolveComponent("Deposits")!
  const _component_InternalTransferRequests = _resolveComponent("InternalTransferRequests")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTabs, (value) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: value,
                    class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                  }, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _withModifiers(($event: any) => (_ctx.selectTab(value)), ["prevent"]),
                      class: _normalizeClass(["nav-link tab", {'active': _ctx.activeTabName === value}])
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.helper.trans(`transfers.${value}`)) + " ", 1),
                      (_ctx.showBadges && _ctx.getTabPendingCount(value) > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.getTabPendingCount(value)), 1))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_7)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.availableTabs.includes(_ctx.activeTabName) && _ctx.activeTabName === _ctx.Tabs.withdrawals)
        ? (_openBlock(), _createBlock(_component_WithdrawalRequests, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.availableTabs.includes(_ctx.activeTabName) && _ctx.activeTabName === _ctx.Tabs.deposits)
        ? (_openBlock(), _createBlock(_component_Deposits, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.availableTabs.includes(_ctx.activeTabName) && _ctx.activeTabName === _ctx.Tabs.internal)
        ? (_openBlock(), _createBlock(_component_InternalTransferRequests, { key: 2 }))
        : _createCommentVNode("", true)
    ])
  ]))
}